import React from 'react';
import { useForm } from 'react-hook-form';
import { Form } from 'react-bootstrap';
import * as Yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, Link } from 'react-router-dom';
import { resetPassword } from '../shared/store/authSlice';
import Loader from '../shared/displayComponents/loader/Loader';

import './ResetPassword.scss';

const ResetPassword = () => {
  const { register, handleSubmit, errors } = useForm({
    validationSchema: Yup.object({
      email: Yup.string()
        .required()
        .email()
        .label('Email'),
    }),
  });
  const dispatch = useDispatch();
  const history = useHistory();
  const { isLoading } = useSelector(({ shared }) => shared);

  const onSubmit = ({ email }) => {
    dispatch(resetPassword(email, history));
  };

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div className="reset-page">
      <div className="reset-card">
        <div className="reset-card__header">
          <div className="reset-card__icon">
            <i className="fas fa-unlock-alt" />
          </div>
          <h1>Reset Password</h1>
          <p>Enter your email and we&apos;ll send you a new password</p>
        </div>

        <div className="reset-card__body">
          <form className="reset-form" onSubmit={handleSubmit(onSubmit)}>
            <div className="reset-field">
              <label htmlFor="reset-email">Email address</label>
              <div className="reset-input-wrap">
                <i className="fas fa-envelope" />
                <Form.Control
                  id="reset-email"
                  className={errors.email && 'is-invalid'}
                  as="input"
                  name="email"
                  placeholder="you@university.edu"
                  ref={register}
                />
              </div>
              {errors?.email?.message && (
                <p className="reset-error">{errors.email.message}</p>
              )}
            </div>

            <button className="reset-submit-btn" type="submit">
              <i className="fas fa-paper-plane" />
              Send Reset Link
            </button>
          </form>

          <div className="reset-back">
            <Link to="/login">
              <i className="fas fa-arrow-left" />
              Back to Sign In
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
